import {AppPageHeader} from "../../../../core/component/page-header";
import {useHistory, useRouteMatch} from 'react-router-dom';
import React from "react";

export type HeaderProfileProps = {
    createRoute?: string;
    mode?: 'list' | 'form';
    title?: string,
    subtitle?:string,

}

export function HeaderProfile(props: HeaderProfileProps) {
    const urlMatch = useRouteMatch();
    const history = useHistory();

    function getCreateLink(): string {
        return `${urlMatch.url}/create`;
    }

    function getListLink(): string {
        return `list`;
    }
    return (
        <>
            <AppPageHeader
                title={props.title ?? 'Perfis'}
                mode={props.mode}
                subtitle={props.subtitle ?? 'Cadastro de todos os perfis'}
                onCreateLink={getCreateLink()}
                onListLink={getListLink()}
                onBack={() => history.goBack()}
                onCreateLabel={'Adicionar perfil'}
            />
        </>
    );

}
